module.exports = __webpack_public_path__ + "img/dashboard-active.feeed8bd.svg";